<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const VISIBLE_TO_AGENTS = 'visible_to_agents';
const MASKED_FOR_AGENTS = 'masked_for_agents';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();
const isEnabled = ref(false);
const isUpdating = ref(false);

const description = computed(() =>
  isEnabled.value
    ? t('GENERAL_SETTINGS.FORM.CONTACT_PHONE_VISIBILITY.VISIBLE_NOTE')
    : t('GENERAL_SETTINGS.FORM.CONTACT_PHONE_VISIBILITY.MASKED_NOTE')
);

watch(
  currentAccount,
  () => {
    const { contact_phone_visibility: phoneVisibility } =
      currentAccount.value?.settings || {};
    isEnabled.value = phoneVisibility === VISIBLE_TO_AGENTS;
  },
  { deep: true, immediate: true }
);

const toggleVisibility = async () => {
  isUpdating.value = true;
  try {
    await updateAccount({
      contact_phone_visibility: isEnabled.value
        ? VISIBLE_TO_AGENTS
        : MASKED_FOR_AGENTS,
    });
    useAlert(t('GENERAL_SETTINGS.FORM.CONTACT_PHONE_VISIBILITY.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.CONTACT_PHONE_VISIBILITY.API.ERROR'));
  } finally {
    isUpdating.value = false;
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.CONTACT_PHONE_VISIBILITY.TITLE')"
    :description="description"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch
          v-model="isEnabled"
          :disabled="isUpdating"
          @change="toggleVisibility"
        />
      </div>
    </template>
  </SectionLayout>
</template>
